import 'bootstrap'
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VuejsDialog from 'vuejs-dialog';
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import { registerLicense } from '@syncfusion/ej2-base';
import { MWCloudAPI } from '@backend/mw-api-sdk';
import jwt_decode from "jwt-decode"
import VueSlugify from 'vue-slugify';
import VueApexCharts from 'vue-apexcharts'
import VSnow from "vsnow";

Vue.use(VuejsDialog, {
  html: true,
  loader: false,
  okText: 'Yes',
  cancelText: 'Cancel',
  animation: 'bounce',
})
Vue.use(BootstrapVue);
Vue.use(DropDownListPlugin);
Vue.use(VuejsDialog);
Vue.use(VueSlugify);
Vue.use(VueApexCharts)
Vue.use(VSnow);

Vue.component('apexchart', VueApexCharts)
registerLicense('ORg4AjUWIQA/Gnt2VVhhQlFaclhJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkFhWH9ZcnNWQmJUUEw=');

Vue.prototype.$http = axios;
Vue.prototype.$apiURL = process.env.VUE_APP_API_URL || 'http://localhost:5000';
Vue.prototype.$portalURL = process.env.VUE_APP_PORTAL_URL || 'http://localhost:8080';
Vue.prototype.$gitlabURL = process.env.VUE_APP_GITLAB_URL_PREFIX || 'https://gitlab.maxwhere.com/spaces-dev/'
Vue.prototype.$crashReporterURL = process.env.VUE_APP_CRASH_REPORTER_URL || 'http://localhost:6666';

const API_MW = new MWCloudAPI({ apiUrl: Vue.prototype.$apiURL });

router.beforeEach((to, from, next) => {
  if(store.getters.isLoggedIn){
    store.commit("setRedirectTo", to.path)
  }
  next();
});

axios.interceptors.response.use(function (response) {
  // Do something with response data
  return response;
}, function (error) {
  if (error.response.status === 403) {
    API_MW._tokenHelper.tokenCheckAndRefresh().then(data => {
      store.commit("setToken", data)
    }).catch(err => {
      store.commit("dropToken", false)
      router.push({ name: "login", params: { error_message: "Session has been expired" } })
    })
  }
  else if (error.response.status === 401) {
    router.push({ name: "login", params: { error_message: "User authentication required" } })
  }
  return Promise.reject(error);
});

axios.interceptors.request.use(async (config) => {
  // Do something before request is sent
  if (config.headers.Authorization && jwt_decode(store.getters.accessToken).exp < Math.round(+new Date() / 1000)) {
    await refresh_token(config.headers.Authorization)
    config.headers = store.getters.authHeader
  }

  return config;
});

const refresh_token = async (auth) => {
  await API_MW.requestHandler.setRefreshToken(store.getters.refreshToken)
  if (store.getters.isLoggedIn) {
    await API_MW._tokenHelper.refreshAccessToken().then(data => {
      store.commit("setToken", data)
    }).catch(err => {
      store.commit("dropToken", false)
      router.push({ name: "login", params: { error_message: "Refresh token has been revoked" } })
    })
  }
}

const login = async (email, password) => {
  await API_MW.authApi.login({ email: email, password: password }).then(data => {
    var decoded = jwt_decode(data['data'].access_token);
    if (decoded.is_superadmin || decoded.is_analyst) {
      store.commit("setToken", data['data'].access_token)
      store.commit("setRefreshToken", data['data'].refresh_token)
    }
    else {
      throw new Error("User has no privilege to access.")
    }

  })

}

var functions = {
  login,
  refresh_token
}

export default functions;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
